module.exports = __webpack_public_path__ + "static/media/trivia_background.71603dca.png";